module.exports = __webpack_public_path__ + "img/Music-low.08b99f10.jpg";